module.exports = __webpack_public_path__ + "assets/img/bc5f624747364823e66b7c7fd46d4853.png";